// import React, { useState } from "react";
// // File completely replaced with optimized version
// import {
//   AppBar,
//   Toolbar,
//   Typography,
//   Button,
//   IconButton,
//   Avatar,
//   Menu,
//   MenuItem,
//   Divider,
//   ListItemIcon,
//   ListItemText,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Box,
//   Chip,
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   useTheme,
//   useMediaQuery,
//   Collapse,
// } from "@mui/material";
// import { useNavigate, useLocation } from "react-router-dom";
// import {
//   Person,
//   Logout,
//   AccountCircle,
//   Email,
//   AdminPanelSettings,
//   Business,
//   People,
//   Close,
//   Settings,
//   Menu as MenuIcon,
//   Description,
//   ExpandLess,
//   ExpandMore,
//   Article,
//   Receipt,
//   AddCircle,
//   List as ListIcon,
//   TrendingUp,
//   AssignmentTurnedIn,
//   AttachMoney,
//   Star,
// } from "@mui/icons-material";
// import {
//   clearUserEmail,
//   clearUserName,
//   clearUserId,
//   clearSignInTime,
//   clearIsAdmin,
//   getUserName,
//   getUserEmail,
//   getIsAdmin,
//   getSignInTime,
// } from "../utils/sessionCheck";
// import { useUserContext } from "./context/UserContext";
// import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
// import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
// import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
// import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
// import { getSuperAdminEmails } from "../utils/superAdminEmails";

// const Navbar = ({ minimal: minimalProp = false }) => {
  
//   const navigate = useNavigate();
//   const location = useLocation();
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   // Automatically set minimal mode for signin page
//   const minimal = minimalProp || location.pathname === "/signin";

//   const { adminSelectedQuotationTemplate, adminSelectedTemplate } = useUserContext();

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [profileDialogOpen, setProfileDialogOpen] = useState(false);
//   const [adminSidebarOpen, setAdminSidebarOpen] = useState(false);
//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [businessDocOpen, setBusinessDocOpen] = useState(false);
//   const [productCatalogOpen, setProductCatalogOpen] = useState(false);
//   const [accountingOpen, setAccountingOpen] = useState(false);
//   const [settingsOpen, setSettingsOpen] = useState(false);
//   const [openStates, setOpenStates] = useState({});
//   const [loyaltyManagementOpen, setLoyaltyManagementOpen] = useState(false);
//   const [quickActionsOpen, setQuickActionsOpen] = useState(true);
//   const [adminPanelOpen, setAdminPanelOpen] = useState(true);

//   const open = Boolean(anchorEl);
//   const userName = getUserName() || "User";
//   const userEmail = getUserEmail() || "";
//   const isAdmin = getIsAdmin() || false;
//   const signInTime = getSignInTime() || "";

//   // Super Admin check (use helper util if available, fallback to env var)
//   const superAdminEmails = (typeof getSuperAdminEmails === 'function' ? getSuperAdminEmails() : null)
//     || (process.env.REACT_APP_SUPER_ADMINS ? process.env.REACT_APP_SUPER_ADMINS.split(',').map(email => email.trim().toLowerCase()) : []);
//   const isSuperAdmin = !!userEmail && superAdminEmails.includes(userEmail.trim().toLowerCase());

  
//   const getInitials = (name) => {
//     if (!name) return "";
//     return name
//       .split(" ")
//       .map((word) => word.charAt(0))
//       .join("")
//       .toUpperCase()
//       .slice(0, 2);
//   };

//   const formatSignInTime = (timestamp) => {
//     if (!timestamp) return "N/A";
//     try {
//       const date = new Date(timestamp);
//       return date.toLocaleString();
//     } catch (error) {
//       return "N/A";
//     }
//   };

//   const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
//   const handleProfileMenuClose = () => setAnchorEl(null);
//   const handleAdminSidebarToggle = () => setAdminSidebarOpen(!adminSidebarOpen);
//   const handleAdminSidebarClose = () => setAdminSidebarOpen(false);
//   const handleMobileMenuToggle = () => setMobileMenuOpen(!mobileMenuOpen);
//   const handleMobileMenuClose = () => setMobileMenuOpen(false);

//   const handleViewProfile = () => {
//     handleProfileMenuClose();
//     setProfileDialogOpen(true);
//   };

//   const handleCloseProfileDialog = () => setProfileDialogOpen(false);

//   const handleLogout = () => {
//     clearUserEmail();
//     clearUserName();
//     clearUserId();
//     clearSignInTime();
//     clearIsAdmin();
//     handleProfileMenuClose();
//     navigate("/signin");
//   };

//   const handleAdminNavigation = (path) => {
//     navigate(path);
//     handleAdminSidebarClose();
//   };

//   const handleMobileNavigation = (path) => {
//     navigate(path);
//     handleMobileMenuClose();
//   };

//   const handleNavigationAndClose = (path) => {
//     navigate(path);
//     handleAdminSidebarClose();
//   };

//   const handleSettingsClick = () => {
//     setSettingsOpen(!settingsOpen);
//   };

//   const handleInvoiceNavigation = () => {
//     if (isAdmin) {
//       if (adminSelectedTemplate) {
//         navigate(`/invoice-templates/${adminSelectedTemplate}`);
//       } else {
//         navigate('/invoice-templates');
//       }
//     } else {
//       if (adminSelectedTemplate) {
//         navigate(`/invoice-templates/${adminSelectedTemplate}`);
//       }
//     }
//     handleAdminSidebarClose();
//   };

//   const handleQuotationNavigation = () => {
//     if (isAdmin) {
//       if (adminSelectedQuotationTemplate) {
//         navigate(`/quotation-templates/${adminSelectedQuotationTemplate}`);
//       } else {
//         navigate('/quotation-templates');
//       }
//     } else {
//       if (adminSelectedQuotationTemplate) {
//         navigate(`/quotation-templates/${adminSelectedQuotationTemplate}`);
//       }
//     }
//     handleAdminSidebarClose();
//   };

//   // Tenant Management menu item for super admin
//   const tenantMenuItem = [
//     {
//       text: "Tenant Management",
//       icon: <Business />,
//       action: () => handleAdminNavigation("/TenantManagement"), // run via admin sidebar
//     },
//   ];

//   // Quick actions for Users and App Admins
//   const quickActionItems = [
//     {
//       text: "Business Document",
//       icon: <Description />,
//       onClick: () => setBusinessDocOpen(!businessDocOpen),
//       subItems: [
//         {
//           text: "Invoice",
//           icon: <Description />,
//           action: handleInvoiceNavigation,
//         },
//         {
//           text: "Quotation",
//           icon: <Article />,
//           action: handleQuotationNavigation,
//         },
//         {
//           text: "Credit Note",
//           icon: <Receipt />,
//           action: () => handleNavigationAndClose("/creditNote"),
//         },
//         {
//           text: "History",
//           icon: <DocumentScannerIcon />,
//           action: () => handleNavigationAndClose("/GeneratedDocuments"),
//         },
//       ],
//     },
//     {
//       text: "Product Catalogue",
//       icon: <ProductionQuantityLimitsIcon />,
//       onClick: () => setProductCatalogOpen(!productCatalogOpen),
//       subItems: [
//         {
//           text: "Add Product",
//           icon: <AddCircle />,
//           path: "/AddProduct",
//           action: () => handleNavigationAndClose("/AddProduct"),
//         },
//         {
//           text: "Product List",
//           icon: <ListIcon />,
//           path: "/ViewProducts",
//           action: () => handleNavigationAndClose("/ViewProducts"),
//         },
//       ],
//     },
//     {
//       text: "Accounting",
//       icon: <AccountBalanceWalletIcon />,
//       onClick: () => setAccountingOpen(!accountingOpen),
//       subItems: [
//         {
//           text: "Expense",
//           icon: <MonetizationOnIcon />,
//           path: "/accounting/expenses",
//           action: () => handleNavigationAndClose("/accounting/expenses"),
//         },
//         {
//           text: "Statement",
//           icon: <DocumentScannerIcon />,
//           path: "/accounting/transactions",
//           action: () => handleNavigationAndClose("/accounting/transactions"),
//         },
//         {
//           text: "Configuration",
//           icon: <Settings />,
//           path: "/accounting/config",
//           action: () => handleNavigationAndClose("/accounting/config"),
//         },
//             {
//               text: "GST",
//               icon: <TrendingUp />,
//               subItems: [
//                 {
//                   text: "GST Dashboard",
//                   icon: <DocumentScannerIcon />,
//                   path: "/accounting/gst",
//                   action: () => handleNavigationAndClose("/accounting/gst"),
//                 },
//                 {
//                   text: "Tax Report",
//                   icon: <DocumentScannerIcon />,
//                   path: "/tax-report",
//                   action: () => handleNavigationAndClose("/tax-report"),
//                 },
//               ],
//             },
//         {
//           text: "Receivables",
//           icon: <AssignmentTurnedIn />,
//           path: "/accounting/receivables",
//           action: () => handleNavigationAndClose("/accounting/receivables"),
//           disabled: true,
//         },
//         {
//           text: "Dues",
//           icon: <AttachMoney />,
//           path: "/accounting/dues",
//           action: () => handleNavigationAndClose("/accounting/dues"),
//           disabled: true,
//         },
//       ],
//     },
//   ];

//   // Menu items specific to App Admins
//   const adminMenuItems = [
//     {
//       text: "User Management",
//       icon: <People />,
//       path: "/admin/user-management",
//     },
//     {
//       text: "Settings",
//       icon: <Settings />,
//       onClick: handleSettingsClick,
//       subItems: [
//         {
//           text: "Invoice Templates",
//           icon: <Description />,
//           path: "/invoice-templates",
//         },
//         {
//           text: "Quotation Templates",
//           icon: <Article />,
//           path: "/quotation-templates",
//         },
//       ],
//     },
//   ];

//   // Loyalty Management menu item for all users
//   const loyaltyManagementItems = [
//     {
//       text: "Loyalty Management",
//       icon: <Star />,
//       onClick: () => setLoyaltyManagementOpen(!loyaltyManagementOpen),
//       subItems: [
//         {
//           text: "Customer Loyalty",
//           icon: <Star />,
//           path: "/loyalty/customers",
//           action: () => handleNavigationAndClose("/loyalty/customers"),
//           disabled: true,
//         },
//         {
//           text: "Rewards Program",
//           icon: <TrendingUp />,
//           path: "/loyalty/rewards",
//           action: () => handleNavigationAndClose("/loyalty/rewards"),
//           disabled: true,
//         },
//         {
//           text: "Loyalty Reports",
//           icon: <DocumentScannerIcon />,
//           path: "/loyalty/reports",
//           action: () => handleNavigationAndClose("/loyalty/reports"),
//           disabled: true,
//         },
//       ],
//     },
//   ];
  

//   const toggleOpen = (key) => setOpenStates((p) => ({ ...p, [key]: !p[key] }));

//   const renderNavItems = (items, level = 0) => {
//     return items.map((item, index) => {
//       const paddingLeft = 2 + level * 2;

//       if (item.subItems) {
//         // Determine which state to use for collapse (preserve existing behavior for top-level labels)
//         let isOpen = openStates[item.text];
//         if (isOpen === undefined) {
//           if (item.text === "Business Document") isOpen = businessDocOpen;
//           else if (item.text === "Product Catalogue") isOpen = productCatalogOpen;
//           else if (item.text === "Accounting") isOpen = accountingOpen;
//           else if (item.text === "Settings") isOpen = settingsOpen;
//           else if (item.text === "Loyalty Management") isOpen = loyaltyManagementOpen;
//           else isOpen = false;
//         }

//         return (
//           <React.Fragment key={index}>
//             <ListItemButton onClick={item.onClick || (() => toggleOpen(item.text))}>
//               {item.icon && (
//                 <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
//               )}
//               <ListItemText primary={item.text} />
//               {isOpen ? <ExpandLess /> : <ExpandMore />}
//             </ListItemButton>
//             <Collapse in={isOpen} timeout="auto" unmountOnExit>
//               <List component="div" disablePadding sx={{ overflow: 'visible' }}>
//                 {item.subItems.map((subItem, subIndex) => {
//                   if (subItem.subItems) {
//                     const nestedOpen = openStates[subItem.text] || false;
//                     return (
//                       <React.Fragment key={subIndex}>
//                         <ListItemButton sx={{ pl: paddingLeft + 2 }} onClick={() => toggleOpen(subItem.text)}>
//                           {subItem.icon && (
//                             <ListItemIcon sx={{ minWidth: 40 }}>{subItem.icon}</ListItemIcon>
//                           )}
//                           <ListItemText primary={subItem.text} />
//                           {nestedOpen ? <ExpandLess /> : <ExpandMore />}
//                         </ListItemButton>
//                         <Collapse in={nestedOpen} timeout="auto" unmountOnExit>
//                           <List component="div" disablePadding sx={{ overflow: 'visible' }}>
//                             {subItem.subItems.map((deepItem, deepIndex) => (
//                               <ListItemButton
//                                 key={deepIndex}
//                                 sx={{ pl: paddingLeft + 4 }}
//                                 onClick={() => deepItem.action ? deepItem.action() : handleNavigationAndClose(deepItem.path)}
//                                 disabled={deepItem.disabled}
//                               >
//                                 {deepItem.icon && (
//                                   <ListItemIcon sx={{ minWidth: 40 }}>{deepItem.icon}</ListItemIcon>
//                                 )}
//                                 <ListItemText primary={deepItem.text} />
//                               </ListItemButton>
//                             ))}
//                           </List>
//                         </Collapse>
//                       </React.Fragment>
//                     );
//                   }

//                   return (
//                     <ListItemButton
//                       key={subIndex}
//                       sx={{ pl: paddingLeft + 2 }}
//                       onClick={() => (item.text === "Settings" ? handleAdminNavigation(subItem.path) : subItem.action ? subItem.action() : handleNavigationAndClose(subItem.path))}
//                       disabled={subItem.disabled}
//                     >
//                       {subItem.icon && (
//                         <ListItemIcon sx={{ minWidth: 40 }}>{subItem.icon}</ListItemIcon>
//                       )}
//                       <ListItemText primary={subItem.text} />
//                     </ListItemButton>
//                   );
//                 })}
//               </List>
//             </Collapse>
//             {index < items.length - 1 && <Divider sx={{ my: 0.5 }} />}
//           </React.Fragment>
//         );
//       }

//       return (
//         <ListItem key={index} disablePadding>
//           <ListItemButton
//             onClick={item.action || (() => handleNavigationAndClose(item.path))}
//             sx={{
//               py: 1.5,
//               px: 2,
//               "&:hover": {
//                 backgroundColor: theme.palette.action.hover,
//               },
//             }}
//           >
//             {item.icon && (
//               <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
//             )}
//             <ListItemText
//               primary={item.text}
//               primaryTypographyProps={{
//                 fontSize: "0.95rem",
//                 fontWeight: 500,
//               }}
//             />
//           </ListItemButton>
//         </ListItem>
//       );
//     });
//   };

//   return (
//     <>
//       <AppBar position="fixed"
//         sx={{
//           background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
//           boxShadow: 'none'
//         }}
//       >
//         <Toolbar>
//           <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
//             {/* Hide hamburger in minimal mode */}
//             {!minimal && (
//               <IconButton
//                 color="inherit"
//                 onClick={handleAdminSidebarToggle}
//                 edge="start"
//                 sx={{ mr: 2 }}
//               >
//                 <MenuIcon />
//               </IconButton>
//             )}
//             <Typography variant="h6" component="div">
//               {/* Conditional rendering: If minimal mode, show plain text, else show clickable Button */}
//               {minimal ? (
//                 <Typography variant="h6" color="inherit" sx={{ fontWeight: 500 }}>
//                   Invoquot
//                 </Typography>
//               ) : (
//                 <Button color="inherit" onClick={() => navigate(isSuperAdmin ? "/TenantManagement" : "/homepage")}>
//                   Invoquot
//                 </Button>
//               )}
//             </Typography>
//           </Box>

//           {/* Hide avatar in minimal mode */}
//           {!minimal && (
//             isMobile ? (
//               <IconButton
//                 color="inherit"
//                 edge="end"
//                 onClick={handleProfileMenuOpen}
//               >
//                 <Avatar sx={{ width: 32, height: 32 }}>
//                   {getInitials(userName)}
//                 </Avatar>
//               </IconButton>
//             ) : (
//               <IconButton
//                 color="inherit"
//                 onClick={handleProfileMenuOpen}
//                 sx={{ ml: 2 }}
//               >
//                 <Avatar sx={{ width: 32, height: 32 }}>
//                   {getInitials(userName)}
//                 </Avatar>
//               </IconButton>
//             )
//           )}
//         </Toolbar>
//       </AppBar>
//       <Box sx={{ height: { xs: 56, sm: 64 } }} />

//       {/* Hide menus, drawers, and dialogs in minimal mode */}
//       {!minimal && (
//         <>
//           <Menu
//             id="profile-menu"
//             anchorEl={anchorEl}
//             open={open}
//             onClose={handleProfileMenuClose}
//             transformOrigin={{ horizontal: "left", vertical: "top" }}
//             anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
//           >
//             <MenuItem disabled>
//               <ListItemIcon>
//                 <AccountCircle />
//               </ListItemIcon>
//               <ListItemText primary={userName} secondary={userEmail} />
//             </MenuItem>
//             {isSuperAdmin ? (
//               <MenuItem disabled>
//                 <ListItemText
//                   primary="Super Admin"
//                   sx={{ color: "error.main", fontWeight: "bold" }}
//                 />
//               </MenuItem>
//             ) : isAdmin ? (
//               <MenuItem disabled>
//                 <ListItemText
//                   primary="Admin"
//                   sx={{ color: "primary.main", fontWeight: "bold" }}
//                 />
//               </MenuItem>
//             ) : null}
//             <Divider />
//             <MenuItem onClick={handleViewProfile}>
//               <ListItemIcon>
//                 <Person />
//               </ListItemIcon>
//               <ListItemText primary="View Profile" />
//             </MenuItem>
//             <Divider />
//             <MenuItem onClick={handleLogout}>
//               <ListItemIcon>
//                 <Logout />
//               </ListItemIcon>
//               <ListItemText primary="Logout" />
//             </MenuItem>
//           </Menu>

//           <Drawer
//             anchor="right"
//             open={mobileMenuOpen}
//             onClose={handleMobileMenuClose}
//           >
//             <Box sx={{ width: 250 }} role="presentation">
//               <List>{renderNavItems(quickActionItems)}</List>
//             </Box>
//           </Drawer>

//           <Drawer
//             anchor="left"
//             open={adminSidebarOpen}
//             onClose={handleAdminSidebarClose}
//             PaperProps={{
//               sx: {
//                 width: 280,
//                 backgroundColor: theme.palette.background.paper,
//               },
//             }}
//           >
//             <Box sx={{ width: 280, display: 'flex', flexDirection: 'column', height: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   padding: theme.spacing(2),
//                   backgroundColor: theme.palette.primary.main,
//                   color: theme.palette.primary.contrastText,
//                 }}
//               >
//                 <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
//                   <AdminPanelSettings />
//                   <Typography variant="h6">Menu</Typography>
//                 </Box>
//                 <IconButton
//                   onClick={handleAdminSidebarClose}
//                   sx={{ color: theme.palette.primary.contrastText }}
//                 >
//                   <Close />
//                 </IconButton>
//               </Box>

//               {/* START: Role-based menu rendering */}
//               {isSuperAdmin ? (
//                 // --- Super Admin View ---
//                 <>
//                   <List sx={{ pt: 0, flex: 1, overflowY: 'auto', overflow: 'visible' }}>
//                     {renderNavItems(tenantMenuItem)}
//                   </List>
//                   <Box sx={{ mt: 'auto' }}>
//                     <Divider sx={{ my: 2 }} />
//                     <Box sx={{ px: 2, pb: 2 }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Logged in as: {userName}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </>
//               ) : isAdmin ? (
//                 // --- App Admin View ---
//                 <>
//                   <Box 
//                     sx={{ px: 2, pt: 2, pb: 1, mb: 1, borderLeft: '4px solid', borderColor: 'primary.main', backgroundColor: 'rgba(33, 150, 243, 0.08)', py: 1.5, borderRadius: '4px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//                     onClick={() => setQuickActionsOpen(!quickActionsOpen)}
//                   >
//                     <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', fontSize: '0.75rem', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                       QUICK ACTIONS
//                     </Typography>
//                     {quickActionsOpen ? <ExpandLess /> : <ExpandMore />}
//                   </Box>
//                   <Collapse in={quickActionsOpen} timeout="auto" unmountOnExit>
//                     <List sx={{ pt: 1, pb: 2, pl: 1, pr: 1, backgroundColor: 'rgba(33, 150, 243, 0.04)', borderRadius: '4px', mx: 1, mb: 2 }}>
//                       {renderNavItems(quickActionItems)}
//                     </List>
//                   </Collapse>
//                   <Divider sx={{ my: 1 }} />
//                   <Box 
//                     sx={{ px: 2, pb: 1, mb: 1, borderLeft: '4px solid', borderColor: 'warning.main', backgroundColor: 'rgba(255, 193, 7, 0.08)', py: 1.5, borderRadius: '4px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 10 }}
//                     onClick={() => setLoyaltyManagementOpen(!loyaltyManagementOpen)}
//                   >
//                     <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'warning.main', fontSize: '0.75rem', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                       LOYALTY MANAGEMENT
//                     </Typography>
//                     {loyaltyManagementOpen ? <ExpandLess /> : <ExpandMore />}
//                   </Box>
//                   <Collapse in={loyaltyManagementOpen} timeout="auto" unmountOnExit>
//                     <List sx={{ pt: 1, pb: 2, pl: 1, pr: 1, overflowY: 'auto', backgroundColor: 'rgba(255, 193, 7, 0.04)', borderRadius: '4px', mx: 1, mb: 2 }}>
//                       {renderNavItems(loyaltyManagementItems)}
//                     </List>
//                   </Collapse>
//                   <Divider sx={{ my: 2 }} />
//                   <Box 
//                     sx={{ px: 2, pb: 1, mb: 3, borderLeft: '4px solid', borderColor: 'secondary.main', backgroundColor: 'rgba(244, 67, 54, 0.08)', py: 1.5, borderRadius: '4px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 10 }}
//                     onClick={() => setAdminPanelOpen(!adminPanelOpen)}
//                   >
//                     <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'secondary.main', fontSize: '0.75rem', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                       ADMIN PANEL
//                     </Typography>
//                     {adminPanelOpen ? <ExpandLess /> : <ExpandMore />}
//                   </Box>
//                   <Collapse in={adminPanelOpen} timeout="auto" unmountOnExit>
//                     <List sx={{ pt: 1, pb: 2, pl: 1, pr: 1, overflowY: 'auto', backgroundColor: 'rgba(244, 67, 54, 0.04)', borderRadius: '4px', mx: 1, mb: 2 }}>
//                       {renderNavItems(adminMenuItems)}
//                     </List>
//                   </Collapse>
//                   <Box sx={{ mt: 'auto' }}>
//                     <Divider sx={{ my: 2 }} />
//                     <Box sx={{ px: 2, pb: 2 }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Logged in as: {userName}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </>
//               ) : (
//                 // --- Regular User View ---
//                 <>
//                   <Box 
//                     sx={{ px: 2, pt: 2, pb: 1, mb: 1, borderLeft: '4px solid', borderColor: 'primary.main', backgroundColor: 'rgba(33, 150, 243, 0.08)', py: 1.5, borderRadius: '4px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
//                     onClick={() => setQuickActionsOpen(!quickActionsOpen)}
//                   >
//                     <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'primary.main', fontSize: '0.75rem', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                       ⚡ QUICK ACTIONS
//                     </Typography>
//                     {quickActionsOpen ? <ExpandLess /> : <ExpandMore />}
//                   </Box>
//                   <Collapse in={quickActionsOpen} timeout="auto" unmountOnExit>
//                     <List sx={{ pt: 1, pb: 2, pl: 1, pr: 1, backgroundColor: 'rgba(33, 150, 243, 0.04)', borderRadius: '4px', mx: 1, mb: 2 }}>
//                       {renderNavItems(quickActionItems)}
//                     </List>
//                   </Collapse>
//                   <Divider sx={{ my: 2 }} />
//                   <Box 
//                     sx={{ px: 2, pb: 1, mb: 3, borderLeft: '4px solid', borderColor: 'warning.main', backgroundColor: 'rgba(255, 193, 7, 0.08)', py: 1.5, borderRadius: '4px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative', zIndex: 10 }}
//                     onClick={() => setLoyaltyManagementOpen(!loyaltyManagementOpen)}
//                   >
//                     <Typography variant="subtitle2" sx={{ fontWeight: 700, color: 'warning.main', fontSize: '0.75rem', letterSpacing: '0.5px', textTransform: 'uppercase' }}>
//                       💎 LOYALTY MANAGEMENT
//                     </Typography>
//                     {loyaltyManagementOpen ? <ExpandLess /> : <ExpandMore />}
//                   </Box>
//                   <Collapse in={loyaltyManagementOpen} timeout="auto" unmountOnExit>
//                     <List sx={{ pt: 1, pb: 2, pl: 1, pr: 1, overflowY: 'auto', backgroundColor: 'rgba(255, 193, 7, 0.04)', borderRadius: '4px', mx: 1, mb: 2 }}>
//                       {renderNavItems(loyaltyManagementItems)}
//                     </List>
//                   </Collapse>
//                   <Box sx={{ mt: 'auto' }}>
//                     <Divider sx={{ my: 2 }} />
//                     <Box sx={{ px: 2, pb: 2 }}>
//                       <Typography variant="caption" color="text.secondary">
//                         Logged in as: {userName}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </>
//               )}
//               {/* END: Role-based menu rendering */}
//             </Box>
//           </Drawer>

//           <Dialog
//             open={profileDialogOpen}
//             onClose={handleCloseProfileDialog}
//             maxWidth="sm"
//             fullWidth
//           >
//             <DialogTitle>
//               <Box display="flex" alignItems="center" gap={2}>
//                 <Avatar sx={{ width: 48, height: 48 }}>
//                   {getInitials(userName)}
//                 </Avatar>
//                 <Box>
//                   <Typography variant="h6">{userName}</Typography>
//                   {isSuperAdmin ? (
//                     <Chip
//                       icon={<AdminPanelSettings />}
//                       label="Super Admin"
//                       size="small"
//                       color="error"
//                       variant="outlined"
//                     />
//                   ) : isAdmin ? (
//                     <Chip
//                       icon={<AdminPanelSettings />}
//                       label="Admin"
//                       size="small"
//                       color="primary"
//                       variant="outlined"
//                     />
//                   ) : null}
//                 </Box>
//               </Box>
//             </DialogTitle>
//             <DialogContent>
//               <Box display="flex" flexDirection="column" gap={2}>
//                 <Box display="flex" alignItems="center" gap={2}>
//                   <Email color="action" />
//                   <Typography variant="body1">
//                     {userEmail || "Not provided"}
//                   </Typography>
//                 </Box>
//                 <Box display="flex" alignItems="center" gap={2}>
//                   <AccountCircle color="action" />
//                   <Typography variant="body1">
//                     Last sign in: {formatSignInTime(signInTime)}
//                   </Typography>
//                 </Box>
//               </Box>
//             </DialogContent>
//             <DialogActions>
//               <Button onClick={handleCloseProfileDialog} color="primary">
//                 Close
//               </Button>
//             </DialogActions>
//           </Dialog>
//         </>
//       )}
//     </>
//   );
// };

// export default Navbar;

import React, { useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Chip,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  useTheme,
  useMediaQuery,
  Collapse,
} from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Person,
  Logout,
  AccountCircle,
  Email,
  AdminPanelSettings,
  Business,
  People,
  Close,
  Settings,
  Menu as MenuIcon,
  Description,
  ExpandLess,
  ExpandMore,
  Article,
  Receipt,
  AddCircle,
  List as ListIcon,
  TrendingUp,
  AssignmentTurnedIn,
  AttachMoney,
  Dashboard,
  Star,
} from "@mui/icons-material";
import {
  clearUserEmail,
  clearUserName,
  clearUserId,
  clearSignInTime,
  clearIsAdmin,
  getUserName,
  getUserEmail,
  getIsAdmin,
  getSignInTime,
} from "../utils/sessionCheck";
import { useUserContext } from "./context/UserContext";
import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { getSuperAdminEmails } from "../utils/superAdminEmails";

const Navbar = ({ minimal: minimalProp = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const minimal = minimalProp || location.pathname === "/signin";

  const { adminSelectedQuotationTemplate, adminSelectedTemplate } = useUserContext();

  const [anchorEl, setAnchorEl] = useState(null);
  const [profileDialogOpen, setProfileDialogOpen] = useState(false);
  const [adminSidebarOpen, setAdminSidebarOpen] = useState(false);
  const [openStates, setOpenStates] = useState({});
  const [quickActionsOpen, setQuickActionsOpen] = useState(false);
  const [loyaltyManagementOpen, setLoyaltyManagementOpen] = useState(false);
  const [adminPanelOpen, setAdminPanelOpen] = useState(false);

  const open = Boolean(anchorEl);
  const userName = getUserName() || "User";
  const userEmail = getUserEmail() || "";
  const isAdmin = getIsAdmin() || false;
  const signInTime = getSignInTime() || "";

  const superAdminEmails = (typeof getSuperAdminEmails === 'function' ? getSuperAdminEmails() : null)
    || (process.env.REACT_APP_SUPER_ADMINS ? process.env.REACT_APP_SUPER_ADMINS.split(',').map(email => email.trim().toLowerCase()) : []);
  const isSuperAdmin = !!userEmail && superAdminEmails.includes(userEmail.trim().toLowerCase());

  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .map((word) => word.charAt(0))
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  const formatSignInTime = (timestamp) => {
    if (!timestamp) return "N/A";
    try {
      const date = new Date(timestamp);
      return date.toLocaleString();
    } catch (error) {
      return "N/A";
    }
  };

  const handleProfileMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleProfileMenuClose = () => setAnchorEl(null);
  const handleAdminSidebarToggle = () => setAdminSidebarOpen(!adminSidebarOpen);
  const handleAdminSidebarClose = () => setAdminSidebarOpen(false);

  const handleViewProfile = () => {
    handleProfileMenuClose();
    setProfileDialogOpen(true);
  };

  const handleCloseProfileDialog = () => setProfileDialogOpen(false);

  const handleLogout = () => {
    clearUserEmail();
    clearUserName();
    clearUserId();
    clearSignInTime();
    clearIsAdmin();
    handleProfileMenuClose();
    navigate("/signin");
  };

  const handleNavigationAndClose = (path) => {
    navigate(path);
    handleAdminSidebarClose();
  };

  const handleInvoiceNavigation = () => {
    if (isAdmin && adminSelectedTemplate) {
      navigate(`/invoice-templates/${adminSelectedTemplate}`);
    } else {
      navigate('/invoice-templates');
    }
    handleAdminSidebarClose();
  };

  const handleQuotationNavigation = () => {
    if (isAdmin && adminSelectedQuotationTemplate) {
      navigate(`/quotation-templates/${adminSelectedQuotationTemplate}`);
    } else {
      navigate('/quotation-templates');
    }
    handleAdminSidebarClose();
  };

  const tenantMenuItem = [
    {
      text: "Tenant Management",
      icon: <Business />,
      action: () => handleNavigationAndClose("/TenantManagement"),
    },
  ];

  const quickActionItems = [
    {
      text: "Dashboard",
      icon: <Dashboard />,
      path: "/dashboard",
      onClick: () => handleNavigationAndClose("/dashboard"),
    },
    {
      text: "Business Document",
      icon: <Description />,
      stateKey: "businessDoc",
      subItems: [
        { text: "Invoice", icon: <Description />, action: handleInvoiceNavigation },
        { text: "Quotation", icon: <Article />, action: handleQuotationNavigation },
        { text: "Credit Note", icon: <Receipt />, action: () => handleNavigationAndClose("/creditNote") },
        { text: "History", icon: <DocumentScannerIcon />, action: () => handleNavigationAndClose("/GeneratedDocuments") },
      ],
    },
    {
      text: "Product Catalogue",
      icon: <ProductionQuantityLimitsIcon />,
      stateKey: "productCatalog",
      subItems: [
        { text: "Add Product", icon: <AddCircle />, action: () => handleNavigationAndClose("/AddProduct") },
        { text: "Product List", icon: <ListIcon />, action: () => handleNavigationAndClose("/ViewProducts") },
      ],
    },
    {
      text: "Accounting",
      icon: <AccountBalanceWalletIcon />,
      stateKey: "accounting",
      subItems: [
        { text: "Expense", icon: <MonetizationOnIcon />, action: () => handleNavigationAndClose("/accounting/expenses") },
        { text: "Statement", icon: <DocumentScannerIcon />, action: () => handleNavigationAndClose("/accounting/transactions") },
        { text: "Configuration", icon: <Settings />, action: () => handleNavigationAndClose("/accounting/config") },
        {
          text: "GST",
          icon: <TrendingUp />,
          stateKey: "gst",
          subItems: [
            { text: "GST Dashboard", icon: <DocumentScannerIcon />, action: () => handleNavigationAndClose("/accounting/gst") },
            { text: "Tax Report", icon: <DocumentScannerIcon />, action: () => handleNavigationAndClose("/tax-report") },
          ],
        },
        { text: "Receivables", icon: <AssignmentTurnedIn />, disabled: true },
        { text: "Dues", icon: <AttachMoney />, disabled: true },
      ],
    },
  ];

  const adminMenuItems = [
    {
      text: "User Management",
      icon: <People />,
      action: () => handleNavigationAndClose("/admin/user-management"),
    },
    {
      text: "Settings",
      icon: <Settings />,
      stateKey: "settings",
      subItems: [
        { text: "Invoice Templates", icon: <Description />, action: () => handleNavigationAndClose("/invoice-templates") },
        { text: "Quotation Templates", icon: <Article />, action: () => handleNavigationAndClose("/quotation-templates") },
      ],
    },
  ];

  const loyaltyManagementItems = [
    {
      text: "Customer Loyalty",
      icon: <Star />,
      disabled: true,
    },
    {
      text: "Rewards Program",
      icon: <TrendingUp />,
      disabled: true,
    },
    {
      text: "Loyalty Reports",
      icon: <DocumentScannerIcon />,
      disabled: true,
    },
  ];

  const toggleOpen = (key) => setOpenStates((p) => ({ ...p, [key]: !p[key] }));

  const renderNavItems = (items, level = 0) => {
    return items.map((item, index) => {
      const paddingLeft = 2 + level * 2;

      if (item.subItems) {
        const isOpen = item.stateKey ? openStates[item.stateKey] || false : false;

        return (
          <Box key={index}>
            <ListItemButton
              onClick={() => item.stateKey && toggleOpen(item.stateKey)}
              sx={{ pl: paddingLeft }}
            >
              {item.icon && (
                <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
              )}
              <ListItemText primary={item.text} />
              {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={isOpen} timeout="auto" unmountOnExit>
              <List component="div" disablePadding sx={{ overflow: 'visible' }}>
                {renderNavItems(item.subItems, level + 1)}
              </List>
            </Collapse>
          </Box>
        );
      }

      return (
        <ListItemButton
          key={index}
          sx={{ pl: paddingLeft }}
          disabled={item.disabled}
          onClick={item.action}
        >
          {item.icon && (
            <ListItemIcon sx={{ minWidth: 40 }}>{item.icon}</ListItemIcon>
          )}
          <ListItemText primary={item.text} />
        </ListItemButton>
      );
    });
  };

  return (
    <>
      <AppBar position="fixed" sx={{ background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)` }}>
        <Toolbar>
          <Box sx={{ display: "flex", alignItems: "center", flexGrow: 1 }}>
            {!minimal && (
              <IconButton color="inherit" onClick={handleAdminSidebarToggle} edge="start" sx={{ mr: 2 }}>
                <MenuIcon />
              </IconButton>
            )}
            <Typography variant="h6" component="div">
              {minimal ? (
                <Typography variant="h6" color="inherit" sx={{ fontWeight: 500 }}>
                  Invoquot
                </Typography>
              ) : (
                <Button color="inherit" onClick={() => navigate(isSuperAdmin ? "/TenantManagement" : "/homepage")}>
                  Invoquot
                </Button>
              )}
            </Typography>
          </Box>
          {!minimal && (
            <IconButton color="inherit" onClick={handleProfileMenuOpen} sx={{ ml: 2 }}>
              <Avatar sx={{ width: 32, height: 32 }}>{getInitials(userName)}</Avatar>
            </IconButton>
          )}
        </Toolbar>
      </AppBar>
      <Box sx={{ height: { xs: 56, sm: 64 } }} />

      {!minimal && (
        <>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleProfileMenuClose}
            transformOrigin={{ horizontal: "left", vertical: "top" }}
            anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
          >
            <MenuItem disabled>
              <ListItemIcon>
                <AccountCircle />
              </ListItemIcon>
              <ListItemText primary={userName} secondary={userEmail} />
            </MenuItem>
            {isSuperAdmin ? (
              <MenuItem disabled>
                <ListItemText primary="Super Admin" sx={{ color: "error.main", fontWeight: "bold" }} />
              </MenuItem>
            ) : isAdmin ? (
              <MenuItem disabled>
                <ListItemText primary="Admin" sx={{ color: "primary.main", fontWeight: "bold" }} />
              </MenuItem>
            ) : null}
            <Divider />
            <MenuItem onClick={handleViewProfile}>
              <ListItemIcon>
                <Person />
              </ListItemIcon>
              <ListItemText primary="View Profile" />
            </MenuItem>
            <Divider />
            <MenuItem onClick={handleLogout}>
              <ListItemIcon>
                <Logout />
              </ListItemIcon>
              <ListItemText primary="Logout" />
            </MenuItem>
          </Menu>

          <Drawer
            anchor="left"
            open={adminSidebarOpen}
            onClose={handleAdminSidebarClose}
            PaperProps={{
              sx: {
                width: 280,
                display: 'flex',
                flexDirection: 'column',
              },
            }}
          >
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
              {/* Header */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  p: 2,
                  bgcolor: theme.palette.primary.main,
                  color: theme.palette.primary.contrastText,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <AdminPanelSettings />
                  <Typography variant="h6">Menu</Typography>
                </Box>
                <IconButton onClick={handleAdminSidebarClose} sx={{ color: 'inherit' }}>
                  <Close />
                </IconButton>
              </Box>

              {/* Scrollable Content */}
              <Box sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
                {isSuperAdmin ? (
                  <List sx={{ pt: 0 }}>
                    {renderNavItems(tenantMenuItem)}
                  </List>
                ) : isAdmin ? (
                  <>
                    {/* Quick Actions Section */}
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          mx: 2,
                          mb: 1,
                          px: 2,
                          py: 1.5,
                          borderLeft: '4px solid',
                          borderColor: 'primary.main',
                          bgcolor: 'rgba(33, 150, 243, 0.08)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => setQuickActionsOpen(!quickActionsOpen)}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: 'primary.main',
                            fontSize: '0.75rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                          }}
                        >
                          QUICK ACTIONS
                        </Typography>
                        {quickActionsOpen ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={quickActionsOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ mx: 1, mb: 2, bgcolor: 'rgba(33, 150, 243, 0.04)', borderRadius: '4px' }}>
                          <List disablePadding>
                            {renderNavItems(quickActionItems)}
                          </List>
                        </Box>
                      </Collapse>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    {/* Loyalty Management Section */}
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          mx: 2,
                          mb: 1,
                          px: 2,
                          py: 1.5,
                          borderLeft: '4px solid',
                          borderColor: 'warning.main',
                          bgcolor: 'rgba(255, 193, 7, 0.08)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => setLoyaltyManagementOpen(!loyaltyManagementOpen)}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: 'warning.main',
                            fontSize: '0.75rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                          }}
                        >
                          LOYALTY MANAGEMENT
                        </Typography>
                        {loyaltyManagementOpen ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={loyaltyManagementOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ mx: 1, mb: 2, bgcolor: 'rgba(255, 193, 7, 0.04)', borderRadius: '4px' }}>
                          <List disablePadding>
                            {renderNavItems(loyaltyManagementItems)}
                          </List>
                        </Box>
                      </Collapse>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    {/* Admin Panel Section */}
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          mx: 2,
                          mb: 1,
                          px: 2,
                          py: 1.5,
                          borderLeft: '4px solid',
                          borderColor: 'secondary.main',
                          bgcolor: 'rgba(244, 67, 54, 0.08)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => setAdminPanelOpen(!adminPanelOpen)}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: 'secondary.main',
                            fontSize: '0.75rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                          }}
                        >
                          ADMIN PANEL
                        </Typography>
                        {adminPanelOpen ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={adminPanelOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ mx: 1, mb: 2, bgcolor: 'rgba(244, 67, 54, 0.04)', borderRadius: '4px' }}>
                          <List disablePadding>
                            {renderNavItems(adminMenuItems)}
                          </List>
                        </Box>
                      </Collapse>
                    </Box>
                  </>
                ) : (
                  <>
                    {/* Quick Actions Section */}
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          mx: 2,
                          mb: 1,
                          px: 2,
                          py: 1.5,
                          borderLeft: '4px solid',
                          borderColor: 'primary.main',
                          bgcolor: 'rgba(33, 150, 243, 0.08)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => setQuickActionsOpen(!quickActionsOpen)}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: 'primary.main',
                            fontSize: '0.75rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                          }}
                        >
                          ⚡ QUICK ACTIONS
                        </Typography>
                        {quickActionsOpen ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={quickActionsOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ mx: 1, mb: 2, bgcolor: 'rgba(33, 150, 243, 0.04)', borderRadius: '4px' }}>
                          <List disablePadding>
                            {renderNavItems(quickActionItems)}
                          </List>
                        </Box>
                      </Collapse>
                    </Box>

                    <Divider sx={{ my: 1 }} />

                    {/* Loyalty Management Section */}
                    <Box sx={{ mt: 2 }}>
                      <Box
                        sx={{
                          mx: 2,
                          mb: 1,
                          px: 2,
                          py: 1.5,
                          borderLeft: '4px solid',
                          borderColor: 'warning.main',
                          bgcolor: 'rgba(255, 193, 7, 0.08)',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                        onClick={() => setLoyaltyManagementOpen(!loyaltyManagementOpen)}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{
                            fontWeight: 700,
                            color: 'warning.main',
                            fontSize: '0.75rem',
                            letterSpacing: '0.5px',
                            textTransform: 'uppercase',
                          }}
                        >
                          💎 LOYALTY MANAGEMENT
                        </Typography>
                        {loyaltyManagementOpen ? <ExpandLess /> : <ExpandMore />}
                      </Box>
                      <Collapse in={loyaltyManagementOpen} timeout="auto" unmountOnExit>
                        <Box sx={{ mx: 1, mb: 2, bgcolor: 'rgba(255, 193, 7, 0.04)', borderRadius: '4px' }}>
                          <List disablePadding>
                            {renderNavItems(loyaltyManagementItems)}
                          </List>
                        </Box>
                      </Collapse>
                    </Box>
                  </>
                )}
              </Box>

              {/* Footer */}
              <Box sx={{ mt: 'auto', borderTop: 1, borderColor: 'divider' }}>
                <Box sx={{ px: 2, py: 2 }}>
                  <Typography variant="caption" color="text.secondary">
                    Logged in as: {userName}
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Drawer>

          <Dialog
            open={profileDialogOpen}
            onClose={handleCloseProfileDialog}
            maxWidth="sm"
            fullWidth
          >
            <DialogTitle>
              <Box display="flex" alignItems="center" gap={2}>
                <Avatar sx={{ width: 48, height: 48 }}>
                  {getInitials(userName)}
                </Avatar>
                <Box>
                  <Typography variant="h6">{userName}</Typography>
                  {isSuperAdmin ? (
                    <Chip
                      icon={<AdminPanelSettings />}
                      label="Super Admin"
                      size="small"
                      color="error"
                      variant="outlined"
                    />
                  ) : isAdmin ? (
                    <Chip
                      icon={<AdminPanelSettings />}
                      label="Admin"
                      size="small"
                      color="primary"
                      variant="outlined"
                    />
                  ) : null}
                </Box>
              </Box>
            </DialogTitle>
            <DialogContent>
              <Box display="flex" flexDirection="column" gap={2} sx={{ mt: 2 }}>
                <Box display="flex" alignItems="center" gap={2}>
                  <Email color="action" />
                  <Typography variant="body1">
                    {userEmail || "Not provided"}
                  </Typography>
                </Box>
                <Box display="flex" alignItems="center" gap={2}>
                  <AccountCircle color="action" />
                  <Typography variant="body1">
                    Last sign in: {formatSignInTime(signInTime)}
                  </Typography>
                </Box>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseProfileDialog} color="primary">
                Close
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )}
    </>
  );
};

export default Navbar;
